import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  event_name: null,
  event_category: 'Findation',
  event_action: 'Widget',
  event_label: null, // status of the action

};

function trackFindationWidget(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('findationWidget', trackFindationWidget);
